import { isFinite, some } from 'lodash/fp';
import {
  CLIENT_TYPE,
  DealerCashRuleType,
  FinanceType,
} from '@upstart/harmony/lib/constants';
import {
  getDealerFlow,
  ControlPanelSteps,
} from '@upstart/harmony/lib/flow-utils';
import { getDefaultFinanceType } from '@upstart/harmony/lib/dealer-utils';
import { getAllFinanceTypesForCar } from '@upstart/harmony/lib/deal-utils';
import { getClientType } from './utils';

export const getPeriodicPaymentFromOffer = (offer, useBiweekly) => {
  if (useBiweekly) {
    return isFinite(offer.estimatedMonthlyPayment)
      ? offer.estimatedMonthlyPayment / 2
      : offer.estimatedMonthlyPayment;
  }
  return offer.estimatedMonthlyPayment;
};

export const isDepositEnabled = dealer =>
  getDealerFlow(dealer)[CLIENT_TYPE.ONLINE].findIndex(
    step => step.id === ControlPanelSteps[CLIENT_TYPE.ONLINE].deposit.id,
  ) !== -1;

export const getDealerCashRuleAppliedValue = offer =>
  offer?.dealerCashRule?.type === DealerCashRuleType.PRICE_OFFSET_PERCENT
    ? ((offer?.dealerCashRule?.value || 0) / 100) * (offer?.dealerCash || 0)
    : Math.min(offer?.dealerCashRule?.value || 0, offer?.dealerCash || 0);

export const getLeaseOffersFromPayments = payments => {
  let leaseOffers;
  some(offerGroup => {
    if (offerGroup.financeType === FinanceType.LEASE) {
      leaseOffers = offerGroup;
      return true;
    }
    return false;
  })(payments?.allOffers);
  return leaseOffers;
};

export const getSelectedFinanceType = ({ car, deal, dealer }) => {
  const allFinanceTypesForCar = getAllFinanceTypesForCar({
    car,
    deal,
    dealer,
    clientType: getClientType(deal),
  });
  // First check if deal has finance type selected and that it's still available for car
  const dealFinanceType = deal?.financeType;
  return allFinanceTypesForCar.includes(dealFinanceType)
    ? dealFinanceType
    : getDefaultFinanceType(allFinanceTypesForCar);
};
